module.exports = __webpack_public_path__ + "static/media/appscreen1.8997676e.png";